import { Card } from "shared/components/Card";
import { cx } from "shared/utils";

export const SectionCard = ({
  title,
  children,
  wrapperClassName,
  sectionDisabled = false
}: {
  title: string;
  children: React.ReactNode;
  wrapperClassName?: string;
  sectionDisabled?: boolean;
}) => (
  <Card className="w-full">
    <fieldset disabled={sectionDisabled}>
      <div className="flex items-center h-[72px] px-8 py-6 border-b border-alpha-40">
        <h4 className="text-[16px] leading-6 font-bold text-content-1000">
          {title}
        </h4>
      </div>
      <div
        className={cx(
          "px-8 pt-6 pb-8 flex flex-col gap-6 w-full",
          wrapperClassName
        )}
      >
        {children}
      </div>
    </fieldset>
  </Card>
);
